import { render, staticRenderFns } from "./export_sales.vue?vue&type=template&id=573534c6&"
import script from "./export_sales.vue?vue&type=script&lang=js&"
export * from "./export_sales.vue?vue&type=script&lang=js&"
import style0 from "./export_sales.vue?vue&type=style&index=0&id=573534c6&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kasingkhoo/NestJsProjects/ivm_web_ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('573534c6')) {
      api.createRecord('573534c6', component.options)
    } else {
      api.reload('573534c6', component.options)
    }
    module.hot.accept("./export_sales.vue?vue&type=template&id=573534c6&", function () {
      api.rerender('573534c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ExportExcel/export_sales.vue"
export default component.exports